"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconMap = void 0;
var Components = __importStar(require("./"));
exports.IconMap = {
    abdominalMeasuresOutline: Components.AbdominalMeasuresOutline,
    addProfessionalFilled: Components.AddProfessionalFilled,
    addProfessionalOutline: Components.AddProfessionalOutline,
    adjust: Components.Adjust,
    agile: Components.Agile,
    alignCenter: Components.AlignCenter,
    alignJustify: Components.AlignJustify,
    alignLeft: Components.AlignLeft,
    alignRight: Components.AlignRight,
    angleDoubleLeft: Components.AngleDoubleLeft,
    angleDoubleRight: Components.AngleDoubleRight,
    angleDown: Components.AngleDown,
    angleLeft: Components.AngleLeft,
    angleRight: Components.AngleRight,
    angleUp: Components.AngleUp,
    appleFilled: Components.AppleFilled,
    appleOutline: Components.AppleOutline,
    archiveFilled: Components.ArchiveFilled,
    archiveOutline: Components.ArchiveOutline,
    arrowDown: Components.ArrowDown,
    arrowLeft: Components.ArrowLeft,
    arrowRight: Components.ArrowRight,
    arrowUp: Components.ArrowUp,
    balanceFilled: Components.BalanceFilled,
    balanceOutline: Components.BalanceOutline,
    bandageFilled: Components.BandageFilled,
    bandageOutline: Components.BandageOutline,
    banFilled: Components.BanFilled,
    banOutline: Components.BanOutline,
    batteryFull: Components.BatteryFull,
    batteryLow: Components.BatteryLow,
    batteryMedium: Components.BatteryMedium,
    beach: Components.Beach,
    bellFilled: Components.BellFilled,
    bellOutline: Components.BellOutline,
    bloodPressureFilled: Components.BloodPressureFilled,
    bloodPressureOutline: Components.BloodPressureOutline,
    bold: Components.Bold,
    bookmarkFilled: Components.BookmarkFilled,
    bookmarkOutline: Components.BookmarkOutline,
    boxFilled: Components.BoxFilled,
    boxOutline: Components.BoxOutline,
    braille: Components.Braille,
    bricksFilled: Components.BricksFilled,
    bricksOutline: Components.BricksOutline,
    bridge: Components.Bridge,
    brush: Components.Brush,
    calendarFilled: Components.CalendarFilled,
    calendarOutline: Components.CalendarOutline,
    cameraFilled: Components.CameraFilled,
    cameraOutline: Components.CameraOutline,
    chatFilled: Components.ChatFilled,
    chatOutline: Components.ChatOutline,
    chatViewFilled: Components.ChatViewFilled,
    chatViewOutline: Components.ChatViewOutline,
    checkCircleFilled: Components.CheckCircleFilled,
    checkCircleOutline: Components.CheckCircleOutline,
    checkDefault: Components.CheckDefault,
    clearFormat: Components.ClearFormat,
    clip: Components.Clip,
    clockArrowOutline: Components.ClockArrowOutline,
    clockFilled: Components.ClockFilled,
    clockOutline: Components.ClockOutline,
    cloudFilled: Components.CloudFilled,
    cloudOutline: Components.CloudOutline,
    code: Components.Code,
    continuousMedicine: Components.ContinuousMedicine,
    contrast: Components.Contrast,
    contrastActive: Components.ContrastActive,
    cookieOutline: Components.CookieOutline,
    copyFilled: Components.CopyFilled,
    copyOutline: Components.CopyOutline,
    creditCardFilled: Components.CreditCardFilled,
    creditCardOutline: Components.CreditCardOutline,
    crossFilled: Components.CrossFilled,
    crossOutline: Components.CrossOutline,
    cutleryFilled: Components.CutleryFilled,
    cutleryOutline: Components.CutleryOutline,
    dataCheckFilled: Components.DataCheckFilled,
    dataCheckOutline: Components.DataCheckOutline,
    dataFilled: Components.DataFilled,
    dataOutline: Components.DataOutline,
    deaf: Components.Deaf,
    decreaseFont: Components.DecreaseFont,
    desktopFilled: Components.DesktopFilled,
    desktopOutline: Components.DesktopOutline,
    dogLeashed: Components.DogLeashed,
    dots: Components.Dots,
    download: Components.Download,
    dragdrop: Components.Dragdrop,
    dropFilled: Components.DropFilled,
    dropOutline: Components.DropOutline,
    dumbbellFilled: Components.DumbbellFilled,
    dumbbellOutline: Components.DumbbellOutline,
    emailFilled: Components.EmailFilled,
    emailOutline: Components.EmailOutline,
    exchange: Components.Exchange,
    exclamationDefault: Components.ExclamationDefault,
    exclamationTriangleFilled: Components.ExclamationTriangleFilled,
    exclamationTriangleOutline: Components.ExclamationTriangleOutline,
    expand: Components.Expand,
    eyeFilled: Components.EyeFilled,
    eyeHiddenFilled: Components.EyeHiddenFilled,
    eyeHiddenOutline: Components.EyeHiddenOutline,
    eyeOutline: Components.EyeOutline,
    faucetFilled: Components.FaucetFilled,
    faucetOutline: Components.FaucetOutline,
    fileEmptyFilled: Components.FileEmptyFilled,
    fileEmptyOutline: Components.FileEmptyOutline,
    fileVisualizationFilled: Components.FileVisualizationFilled,
    fileVisualizationOutline: Components.FileVisualizationOutline,
    fileWithItemsFilled: Components.FileWithItemsFilled,
    fileWithItemsOutline: Components.FileWithItemsOutline,
    filterFilled: Components.FilterFilled,
    filterOutline: Components.FilterOutline,
    folderFilled: Components.FolderFilled,
    folderOutline: Components.FolderOutline,
    gearFilled: Components.GearFilled,
    gearOutline: Components.GearOutline,
    glucometer: Components.Glucometer,
    hamburguerMenu: Components.HamburguerMenu,
    headset: Components.Headset,
    heartFilled: Components.HeartFilled,
    heartOutline: Components.HeartOutline,
    heartRateFilled: Components.HeartRateFilled,
    heartRateOutline: Components.HeartRateOutline,
    horus: Components.Horus,
    hospital: Components.Hospital,
    houseFilled: Components.HouseFilled,
    houseOutline: Components.HouseOutline,
    imageFilled: Components.ImageFilled,
    imageOutline: Components.ImageOutline,
    imcFilled: Components.ImcFilled,
    increaseFont: Components.IncreaseFont,
    infoCircleFilled: Components.InfoCircleFilled,
    infoCircleOutline: Components.InfoCircleOutline,
    infoDefault: Components.InfoDefault,
    italic: Components.Italic,
    keyFilled: Components.KeyFilled,
    keyOutline: Components.KeyOutline,
    leafFilled: Components.LeafFilled,
    leafOutline: Components.LeafOutline,
    lightbulbFilled: Components.LightbulbFilled,
    lightbulbOutline: Components.LightbulbOutline,
    link: Components.Link,
    list: Components.List,
    loading: Components.Loading,
    lockCloseFilled: Components.LockCloseFilled,
    lockCloseOutline: Components.LockCloseOutline,
    lockOpenFilled: Components.LockOpenFilled,
    lockOpenOutline: Components.LockOpenOutline,
    lungs: Components.Lungs,
    mapFilled: Components.MapFilled,
    mapMarkerFilled: Components.MapMarkerFilled,
    mapMarkerOutline: Components.MapMarkerOutline,
    mapOutline: Components.MapOutline,
    medicineBottleFilled: Components.MedicineBottleFilled,
    medicineBottleOutline: Components.MedicineBottleOutline,
    microphoneFilled: Components.MicrophoneFilled,
    microphoneOffFilled: Components.MicrophoneOffFilled,
    microphoneOffOutline: Components.MicrophoneOffOutline,
    microphoneOutline: Components.MicrophoneOutline,
    minimize: Components.Minimize,
    minus: Components.Minus,
    minusCircleFilled: Components.MinusCircleFilled,
    module: Components.Module,
    moonFilled: Components.MoonFilled,
    moonOutline: Components.MoonOutline,
    mosquito: Components.Mosquito,
    mugFilled: Components.MugFilled,
    mugOutline: Components.MugOutline,
    multipleUsers: Components.MultipleUsers,
    multipleUsersOutline: Components.MultipleUsersOutline,
    needleFilled: Components.NeedleFilled,
    needleOutline: Components.NeedleOutline,
    noDataFilled: Components.NoDataFilled,
    noDataOutline: Components.NoDataOutline,
    nurse: Components.Nurse,
    nurseOutline: Components.NurseOutline,
    nurseView: Components.NurseView,
    nurseVisualizationOutline: Components.NurseVisualizationOutline,
    o2Filled: Components.O2Filled,
    openDoor: Components.OpenDoor,
    paintBucket: Components.PaintBucket,
    pause: Components.Pause,
    penFilled: Components.PenFilled,
    penOutline: Components.PenOutline,
    penTool: Components.PenTool,
    personExercising: Components.PersonExercising,
    pessoaComDeficiencia: Components.PessoaComDeficiencia,
    petFilled: Components.PetFilled,
    petOutline: Components.PetOutline,
    phoneFilled: Components.PhoneFilled,
    phoneOutline: Components.PhoneOutline,
    pictureInPictureFilled: Components.PictureInPictureFilled,
    pillFilled: Components.PillFilled,
    pillOutline: Components.PillOutline,
    pipeFilled: Components.PipeFilled,
    pipeOutline: Components.PipeOutline,
    playFilled: Components.PlayFilled,
    playOutline: Components.PlayOutline,
    plus: Components.Plus,
    pollFilled: Components.PollFilled,
    pollOutline: Components.PollOutline,
    pregnant: Components.Pregnant,
    presentationFilled: Components.PresentationFilled,
    presentationOutline: Components.PresentationOutline,
    printerFilled: Components.PrinterFilled,
    printerOutline: Components.PrinterOutline,
    qrCode: Components.QrCode,
    questionMarkFilled: Components.QuestionMarkFilled,
    questionMarkOutline: Components.QuestionMarkOutline,
    quoteLeft: Components.QuoteLeft,
    quoteRight: Components.QuoteRight,
    redo: Components.Redo,
    roadFilled: Components.RoadFilled,
    roadOutline: Components.RoadOutline,
    rocket: Components.Rocket,
    rollerBrushFilled: Components.RollerBrushFilled,
    rulerFilled: Components.RulerFilled,
    rulerOutline: Components.RulerOutline,
    screenShareFilled: Components.ScreenShareFilled,
    sendFilled: Components.SendFilled,
    shieldFilled: Components.ShieldFilled,
    shieldOutline: Components.ShieldOutline,
    signLanguage: Components.SignLanguage,
    signOut: Components.SignOut,
    sixtyPlus: Components.SixtyPlus,
    sort: Components.Sort,
    stampFilled: Components.StampFilled,
    starFilled: Components.StarFilled,
    starOutline: Components.StarOutline,
    stethoscopeFilled: Components.StethoscopeFilled,
    stethoscopeOutline: Components.StethoscopeOutline,
    stopFilled: Components.StopFilled,
    stopOutline: Components.StopOutline,
    strikethrough: Components.Strikethrough,
    sunFilled: Components.SunFilled,
    sunrise: Components.Sunrise,
    sync: Components.Sync,
    teddyBear: Components.TeddyBear,
    thermometerFilled: Components.ThermometerFilled,
    thermometerOutline: Components.ThermometerOutline,
    timerFilled: Components.TimerFilled,
    timerOutlined: Components.TimerOutlined,
    timesDefault: Components.TimesDefault,
    timesFilled: Components.TimesFilled,
    timesOutline: Components.TimesOutline,
    trashFilled: Components.TrashFilled,
    trashOutline: Components.TrashOutline,
    underline: Components.Underline,
    undo: Components.Undo,
    universalAccess: Components.UniversalAccess,
    upload: Components.Upload,
    userBan: Components.UserBan,
    userCard: Components.UserCard,
    userCheck: Components.UserCheck,
    userFilled: Components.UserFilled,
    userOutline: Components.UserOutline,
    userReturn: Components.UserReturn,
    userTimes: Components.UserTimes,
    videoFilled: Components.VideoFilled,
    videoOffFilled: Components.VideoOffFilled,
    videoOffOutline: Components.VideoOffOutline,
    videoOutline: Components.VideoOutline,
    volumeFilled: Components.VolumeFilled,
    volumeMuteFilled: Components.VolumeMuteFilled,
    volumeMuteOutline: Components.VolumeMuteOutline,
    volumeOutline: Components.VolumeOutline,
    walker: Components.Walker,
    wheelchair: Components.Wheelchair,
    wifi: Components.Wifi,
    xp: Components.Xp,
    zoomMinusFilled: Components.ZoomMinusFilled,
    zoomMinusOutline: Components.ZoomMinusOutline,
    zoomOutline: Components.ZoomOutline,
    zoomPlusFilled: Components.ZoomPlusFilled,
    zoomPlusOutline: Components.ZoomPlusOutline,
};
//# sourceMappingURL=types.js.map